import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import $ from 'jquery'
import 'element-plus/dist/index.css'
import '@/assets/css/reset.css'
import '@/assets/css/default.css'
import '@/assets/css/font/iconfont.css'
import '@/assets/css/default.css'
import { getCookie } from './utils'
import zhCn  from "element-plus/es/locale/lang/zh-cn"

//jquery.cookie 方法绑定
window.$ = $
window.$.cookie = getCookie

createApp(App).use(store).use(router).use(ElementPlus,{locale:zhCn}).use($).mount('#app')
